// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "vendors" + "." + "5c4b490b5d8d9cbc" + ".css"
}